'use strict';

angular.module('shiftTraderApp')
    .directive('saEmployeeEditor', function () {
      return {
        templateUrl: 'views/directives/saEmployeeEditor.html',
        restrict: 'A',
        scope: {
          me:'=loggedInUser',
          org:'=',
          allPositions: '=positions',
          allUsers: '=users',
          newEmployees: '=newUsers'
        },
        controller: ['$scope', '$q', '$timeout', 'Positions', 'Departments', 'regexStrings', 'Registration', 'SAErrorHandler', 'Users', function($scope, $q, $timeout, Positions, Departments, regexStrings, Registration, SAErrorHandler, Users) {

          $scope.regexStrings = regexStrings;

          $scope.state = {

          };

          if (_.isUndefined($scope.newEmployees)) {
            console.log('New Employees Undefined');
            $scope.newEmployees = [];
          }

          var clearNewEmployee = function() {
            $scope.newEmployee = {
              first_name: '',
              last_name: '',
              email: '',
              phone_number: '',
              _deletable: true
            };
            focusNameInput();
          };

          var calculateWrapperSize = function () {
            // Set width of list wrapper based on max number of cards that can fit
            var listWidth = $('.emp_editor_emp_list_outer_wrapper').width();

            //  width + margin of emp_ card_wrapper
            var cardWidth = $('.emp_card_wrapper').width();
            var minCardMargin = 5;

            var wrapperWidth = listWidth - 2*minCardMargin;
            $scope.numCardsPerRow = Math.floor(wrapperWidth / (2*minCardMargin + cardWidth));
            var cardMargin = (wrapperWidth - $scope.numCardsPerRow*cardWidth) / (2*$scope.numCardsPerRow);

            $('.emp_editor_emp_list_wrapper').css('width', wrapperWidth);
            $('.emp_card_wrapper').css({'margin-left': cardMargin, 'margin-right': cardMargin});
          };

          $scope.firstItemInRow = function(idx) {
            if (idx === 0) {
              return false;
            } else {
              return idx % $scope.numCardsPerRow === 0;
            }
          };

          var focusNameInput = function(timeout) {
            if (_.isNull(timeout)) {
              timeout = 0;
            }
            $timeout(
              function() {
                $('#emp-name').focus();
              }, timeout);
          };

          focusNameInput(1000);
          $timeout(calculateWrapperSize, 0);

          $scope.addEmployee = function() {
            var data = {
              user: {
                first_name: $scope.newEmployee.first_name,
                last_name: $scope.newEmployee.last_name,
                email: $scope.newEmployee.email,
                phone_number: $scope.newEmployee.phone_number
              },
              membership: {
                organization_id: $scope.org.id,
                role: 'employee',
                active: true
              }
            };

            Users.create(data)
                .then(function(newUser) {
                  newUser._deletable = true;
                  $scope.newEmployees.splice(0, 0, newUser);
                  $scope.allUsers.push(newUser);
                  clearNewEmployee();
                  $scope.emp_editor_form.$setPristine();
                  $timeout(calculateWrapperSize, 0);
                }, function (response) {
                  SAErrorHandler.processError(response);
                });
          };

          $scope.removeEmployee = function(emp) {
            emp.$delete({organization_id: $scope.org.id})
                .then(function() {
                  _.remove($scope.newEmployees, {id: emp.id});
                  _.remove($scope.allUsers, {id: emp.id});
                });
            focusNameInput();
          };

          $scope.$on('viewportResizeEvent', function() {
            calculateWrapperSize();
          });

        }]
      };
    });
